import { KEOBONGVIP_DOMAIN } from "@/config";
import { useCompConfig } from "@/context/CompConfigContext";

export function useSiteOrigin() {
  const config = useCompConfig();
  const raw = String(config?.siteUrl || KEOBONGVIP_DOMAIN || "https://keobongvip.top").trim();
  return raw.replace(/\/$/, "");
}

export function absUrl(origin, path) {
  const value = String(path || "").trim();
  if (!value) return origin;
  if (/^https?:\/\//i.test(value)) return value;
  return `${origin}${value.startsWith("/") ? value : `/${value}`}`;
}

export function sameOrigin(origin, href) {
  try {
    return new URL(href, origin).origin === new URL(origin).origin;
  } catch {
    return false;
  }
}
